import { hasPermission, hasClientLogo } from '../../../account/selectors'

const mapStateToProps = state => {
  if (!state.account.company) {
    return {
      name: '---',
      hasMinimumWage: false,
      hasCompliance: false,
      hasLogo: false,
      hasMultipleCompanies: false
    }
  }

  return {
    name: state.account.user.shortName,
    authenticated: state.account.authenticated,
    hasCompliance: hasPermission(state)('hasCompliance'),
    hasMinimumWage: hasPermission(state)('hasMinimumWage'),
    hasPaidLeave: hasPermission(state)('hasPaidLeave'),
    hasLogo: hasClientLogo(state),
    hasMultipleCompanies: (state.account.user.companies && state.account.user.companies.length > 1) || (state.account.user && state.account.user.isAdmin)
  }
}

export default mapStateToProps
